import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29234bee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=29234bee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29234bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29234bee')) {
      api.createRecord('29234bee', component.options)
    } else {
      api.reload('29234bee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29234bee&scoped=true", function () {
      api.rerender('29234bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Screenfull/index.vue"
export default component.exports